import * as Redux from 'redux'
import { Grid } from '@mui/material'
import { connect } from 'react-redux'
import clsx from 'clsx'
import BaseDatePicker from '@Components/Form/BaseDatePicker/BaseDatePicker'
import BaseSelect from '@Components/Form/BaseSelect/BaseSelect'
import { RedditTextField } from '@Components/Form/RedditTextField/RedditTextField'
import UploadImage from '@Components/Form/UploadImage/UploadImage'
import React, { ChangeEvent, useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { CommonService } from '@Services/common.service'
import RegroundAction from '@ClientActions/reground.action'
import { EducatorActionTypes } from '@EducatorStores/educator.action-types'
import { FormService } from '@Services/form.service'
import InputMask from 'react-input-mask'

interface IStudentInfoForm {
    control: any
    errors: any
    watch?: any
    reset?: any
    setValue?: any
    // onSubmitStudentForm?: any
    // getFormData?: any
    getStates?: any
    getCities?: any
    states?: []
    cities?: []
    defaultValue?: any
    detail?: any
    title: string
}

function StudentInfoForm(props: IStudentInfoForm) {
    const {
        // onSubmitStudentForm,
        // getFormData,
        control,
        errors,
        watch,
        reset,
        setValue,
        getStates,
        getCities,
        states,
        cities,
        defaultValue,
        detail,
        title,
    } = props
    const ac = new AbortController()
    // const defaultValues = {
    //     firstName: '',
    //     middleName: '',
    //     lastName: '',
    //     ssnNum: '',
    //     schoolId: '',
    //     address: '',
    //     state: '',
    //     city: '',
    //     zipCode: '',
    //     dob: null,
    //     profileImage: '',
    //     profileImageId: '',
    //     loading: false,
    // }

    // const {
    //     control,
    //     handleSubmit,
    //     formState: { errors },
    //     reset,
    //     setValue,
    //     getValues,
    //     watch,
    // } = useForm({ defaultValues })
    const watchImage = watch('profileImage')
    const watchLoading = watch('loading')

    const handleFileChange = (file: any) => {
        setValue('loading', true)
        CommonService.uploadImage(file)
            .then((response: any) => {
                // // setImageUrl(response?.url)
                setValue('loading', false)
                setValue('profileImageId', response?.id)
                setValue('profileImage', response?.url)
            })
            .catch(() => {
                setValue('loading', false)
            })
    }

    const onRemoveImage = () => {
        setValue('profileImageId', '')
        setValue('profileImage', '')
    }

    // useEffect(() => {
    //     // console.log(watchParents)
    // }, [watchParents])

    const handleSelectChange = (value: any) => {
        setValue('city', '')
        const params = {
            parentCode: value,
        }
        getCities(params)
    }

    useEffect(() => {
        return () => {
            ac.abort()
        }
    }, [])

    useEffect(() => {
        getStates()
    }, [])

    // useEffect(() => {
    //     handleSubmit(onSubmit)()
    // }, [onSubmitStudentForm])

    // const watchLoading = watch('student')

    return (
        <>
            <p className="educator-headline">{title}</p>
            <Grid container spacing={2}>
                <Grid item sm={3}>
                    <UploadImage
                        className={clsx(
                            'w-100 mb-2',
                            errors?.profileImage && true ? 'border-danger' : ''
                        )}
                        style={{ height: 174 }}
                        fileChanged={handleFileChange}
                        imageUrl={watchImage}
                        isLoading={watchLoading}
                        type="upload-profile"
                        remove
                        removeAction={() => onRemoveImage()}
                    />
                </Grid>
                <Grid item sm={9} container spacing={1}>
                    <Grid item sm={3}>
                        <Controller
                            control={control}
                            name="firstName"
                            defaultValue=""
                            rules={{ required: true }}
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                <RedditTextField
                                    {...field}
                                    value={value}
                                    onChange={onChange}
                                    inputRef={ref}
                                    label="First Name"
                                    className="reddit-input w-100"
                                    variant="filled"
                                    error={errors?.firstName && true}
                                    helperText={FormService.getErrorMessage(
                                        errors,
                                        'firstName',
                                        'First Name'
                                    )}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item sm={3}>
                        <Controller
                            control={control}
                            name="middleName"
                            defaultValue=""
                            // rules={{ required: true }}
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                <RedditTextField
                                    {...field}
                                    value={value}
                                    onChange={onChange}
                                    inputRef={ref}
                                    label="Middle Name"
                                    className="reddit-input w-100"
                                    variant="filled"
                                />
                            )}
                        />
                    </Grid>
                    <Grid item sm={3}>
                        <Controller
                            control={control}
                            name="lastName"
                            defaultValue=""
                            rules={{ required: true }}
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                <RedditTextField
                                    {...field}
                                    value={value}
                                    onChange={onChange}
                                    inputRef={ref}
                                    label="Last Name"
                                    className="reddit-input w-100"
                                    variant="filled"
                                    error={errors?.lastName && true}
                                    helperText={FormService.getErrorMessage(
                                        errors,
                                        'lastName',
                                        'Last Name'
                                    )}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item sm={3}>
                        <Controller
                            control={control}
                            name="dob"
                            defaultValue={null}
                            // rules={{ required: true }}
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                <BaseDatePicker
                                    {...field}
                                    label="Date of Birth"
                                    onChange={(e: any) => {
                                        onChange(e)
                                    }}
                                    value={value}
                                    fullWidth
                                    inputRef={ref}
                                    maxDate={new Date()}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item sm={3}>
                        <Controller
                            control={control}
                            name="schoolId"
                            defaultValue=""
                            // rules={{ required: true }}
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                <RedditTextField
                                    {...field}
                                    value={value}
                                    onChange={onChange}
                                    inputRef={ref}
                                    label="School ID"
                                    className="reddit-input w-100"
                                    variant="filled"
                                />
                            )}
                        />
                    </Grid>
                    <Grid item sm={3}>
                        {/* <Controller
                            control={control}
                            name="ssnNum"
                            defaultValue=""
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                <RedditTextField
                                    {...field}
                                    value={value}
                                    onChange={onChange}
                                    inputRef={ref}
                                    label="SSN #"
                                    className="reddit-input w-100"
                                    variant="filled"
                                />
                            )}
                        /> */}
                        <Controller
                            control={control}
                            name="ssnNum"
                            defaultValue=""
                            rules={{ minLength: 11 }}
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                <InputMask
                                    mask="999-99-9999"
                                    value={value}
                                    onChange={(e: ChangeEvent<any>) => {
                                        const validatedValue = e?.target?.value
                                        onChange(
                                            validatedValue?.replaceAll('_', '')
                                        )
                                    }}
                                    className="reddit-input w-100"
                                >
                                    {(inputProps: any) => {
                                        return (
                                            <RedditTextField
                                                {...inputProps}
                                                inputRef={ref}
                                                label="SSN #"
                                                variant="filled"
                                                className="reddit-input w-100"
                                                error={errors?.ssnNum && true}
                                                helperText={FormService.getErrorMessage(
                                                    errors,
                                                    'ssnNum',
                                                    'SSN #',
                                                    'SSN # should be XXX-XX-XXXX'
                                                )}
                                            />
                                        )
                                    }}
                                </InputMask>
                            )}
                        />
                    </Grid>
                    <Grid item sm={6}>
                        <Controller
                            control={control}
                            name="address"
                            defaultValue=""
                            // rules={{ required: true }}
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                <RedditTextField
                                    {...field}
                                    value={value}
                                    onChange={onChange}
                                    inputRef={ref}
                                    label="Address"
                                    className="reddit-input w-100"
                                    variant="filled"
                                />
                            )}
                        />
                    </Grid>
                    <Grid item sm={3}>
                        <Controller
                            control={control}
                            name="state"
                            defaultValue=""
                            // rules={{ required: true }}
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                <BaseSelect
                                    value={value}
                                    onChange={(event: any) => {
                                        onChange(event)
                                        handleSelectChange(event?.target?.value)
                                    }}
                                    options={states}
                                    label="State"
                                    fullWidth
                                />
                            )}
                        />
                    </Grid>
                    <Grid item sm={3}>
                        <Controller
                            control={control}
                            name="city"
                            defaultValue=""
                            // rules={{ required: true }}
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                <BaseSelect
                                    value={value}
                                    onChange={onChange}
                                    options={cities}
                                    label="City"
                                    fullWidth
                                />
                            )}
                        />
                    </Grid>
                    <Grid item sm={3}>
                        {/* <Controller
                            control={control}
                            name="zipCode"
                            defaultValue=""
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                <RedditTextField
                                    {...field}
                                    value={value}
                                    onChange={onChange}
                                    inputRef={ref}
                                    label="Zip Code"
                                    className="reddit-input w-100"
                                    variant="filled"
                                />
                            )}
                        /> */}
                        <Controller
                            control={control}
                            name="zipCode"
                            defaultValue=""
                            rules={{ minLength: 5 }}
                            render={({
                                field: { ref, value, onChange },
                            }: any) => (
                                <InputMask
                                    mask="99999"
                                    value={value}
                                    onChange={(e: ChangeEvent<any>) => {
                                        const validatedValue = e?.target?.value
                                        onChange(
                                            validatedValue?.replaceAll('_', '')
                                        )
                                    }}
                                    className="reddit-input w-100"
                                >
                                    {(inputProps: any) => {
                                        return (
                                            <RedditTextField
                                                {...inputProps}
                                                inputRef={ref}
                                                label="Zip Code"
                                                variant="filled"
                                                error={errors?.zipCode && true}
                                                helperText={FormService.getErrorMessage(
                                                    errors,
                                                    'zipCode',
                                                    'Zip Code',
                                                    'Zip Code should be 5 digit'
                                                )}
                                            />
                                        )
                                    }}
                                </InputMask>
                            )}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

const mapStateToProps = (store: any) => {
    return {
        states: store?.educator?.educatorInfo?.studentStates?.map(
            (item: any) => {
                return {
                    id: item.id,
                    name: item.name,
                    value: item.code,
                }
            }
        ),
        cities: store?.educator?.educatorInfo?.studentCities?.map(
            (item: any) => {
                return {
                    id: item.id,
                    name: item.name,
                    value: item.code,
                }
            }
        ),
    }
}

const mapDispatchToProps = (dispatch: Redux.Dispatch) => {
    return {
        getStates: () =>
            dispatch(
                RegroundAction.getReground(
                    'STATE',
                    EducatorActionTypes.GET_STUDENT_STATES
                ) as any
            ),
        getCities: (params: any) =>
            dispatch(
                RegroundAction.getReground(
                    'CITY',
                    EducatorActionTypes.GET_STUDENT_CITIES,
                    params
                ) as any
            ),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentInfoForm)
